export default (theme) => ({
  title: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  data: {
    textAlign: 'right',
    width: '50%',
  },
  column: {
    width: '50%',
    fontWeight: 600
  },
  table: {
    width: '100%',
    borderSpacing: '10px'
  },
  skeletonTable: {
    padding: 10
  },
  skeletonRow: {
    marginBottom: 8
  },
  defaultText: {
    height: 211,
    lineHeight: '211px',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '28px'
  },
  textContainer: {
    textAlign: 'center',
    height: '144px',
  },
  cardBar: {
    fontSize: 15,
    marginBottom: 5,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  cardContent: {
    padding: '0 0 16px'
  },
  viewOpponent: {
    fontSize: 12,
    marginTop: 20,
    textAlign: 'center'
  },
  viewOpponentText: {
    textDecoration: 'underline',
    width: 'fit-content',
    margin: '0 auto',
    cursor: 'pointer',
    '&:hover' : {
      color: '#008CBA'
    }
  },
  opponentXlText: {
    fontSize: 28
  },
  opponentDrawDate: {
    fontSize: 20,
    marginTop: 10
  },
  textCenter: {
    textAlign: 'center'
  },
  pill: {
    backgroundColor: '#f2f2f2',
    borderRadius: 5,
    padding: '2px 8px',
    width: 40,
    textAlign: 'center',
    marginBottom: 10,
    display: 'inline-block',
    lineHeight: '16px',
    fontSize: '14px'
  },
  vsPill: {
    backgroundColor: '#f2f2f2',
    borderRadius: 5,
    padding: '2px 8px',
    textAlign: 'center',
    marginTop: 55,
    display: 'inline-block',
    lineHeight: '20px',
    fontSize: '14px'
  },
  teamGridItem: {
    textAlign: 'center'
  },
  singleAvatar: {
    margin: '0 auto'
  },
  teamAvatarContainer: {
    height: 60,
    position: 'relative',
    width: '100%',
    maxWidth: '175px',
    margin: '0 auto'
  },
  additionalPlayerAvatar: {
    position: 'absolute',
    left: '45%',
  },
  leadPlayerAvatar: {
    textAlign: 'center',
    position: 'absolute',
    left: '20%',
    [theme.breakpoints.down('xs')]: {
      left: '15%'
    },
  },
  teamName: {
    fontSize: 14,
    marginTop: 10,
  },
  homeClub: {
    fontSize: '14px',
    marginTop: 10,
    textAlign: 'center',
  },
  matchDeadline: {
    fontSize: '14px',
    marginTop: 10,
    textAlign: 'center',
    fontWeight: 500,
    marginBottom: 10,
  },
  vsCard: {
    paddingBottom: [17, '!important']
  },
  viewOpponentsButton: {
    margin: '0 auto'
  },
  card: {
    minHeight: 290
  },
  largeTextMargin: {
    marginTop: 50
  }

});
